import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { ApiError } from '@/lib/api-error';
import { meOptions } from '@/features/auth/api';

export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData(meOptions());
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        throw redirect({
          to: '/sign-in',
          search: { redirect: location.href },
        });
      }
      throw err;
    }
  },
  component: AuthedLayout,
});

function AuthedLayout() {
  return <Outlet />;
}
